import { createAri } from '@atlassian/jira-platform-ari';
import { useRouter } from '@atlassian/jira-router';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';

export const useBoardAri = () => {
	const cloudId = useCloudId();
	const [{ match }] = useRouter();

	return createAri({
		resourceOwner: 'jira-software',
		cloudId,
		resourceType: 'board',
		resourceId: String(match.params.boardId),
	});
};
